import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#121212",
    },
    text: {
      primary: "#ffffff", 
    },
  },
  typography: {
    allVariants: {
      color: "#ffffff", 
    },
  },
});

export default theme;
